/* LASTLOOK - Meta Lead event on Klaviyo waitlist signup */
(function(){
  if(!window.fbq){
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init','1237377361472141');
  }
  var FORM_ID='TtAtKE',fired=false;
  function seen(){try{return sessionStorage.getItem('ll_lead_fired')==='1'}catch(e){return false}}
  function mark(){try{sessionStorage.setItem('ll_lead_fired','1')}catch(e){}}
  window.addEventListener('klaviyoForms',function(e){
    var d=e.detail||{};
    if(d.type!=='submit')return;
    if(d.formId&&d.formId!==FORM_ID)return;
    if(fired||seen())return;
    fired=true;mark();
    var eid='ll-lead-'+Date.now()+'-'+Math.random().toString(36).slice(2,10);
    window.fbq('track','Lead',{content_name:'Waitlist Signup',content_category:'Therapy',value:2.00,currency:'AUD'},{eventID:eid});
    console.log('[LL] Meta Lead fired', eid);
  });
  console.log('[LL] meta-lead listener ready');
})();
